export default __webpack_public_path__ + "static/media/29.b17c1771.jpg";